// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import ArrowDown from "@rpsc/XDL/Icons/IconAngleDown";
import ArrowUp from "@rpsc/XDL/Icons/IconAngleUp";

import { IconWrapper } from "@insite/mobius/Icon";
import { productListFilterAccordionSectionStyles } from "@rpsc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import IconMinus from "@rpsc/XDL/Icons/IconMinus";
import IconPlus from "@rpsc/XDL/Icons/IconPlus";
import IconSearch from "@rpsc/XDL/Icons/IconSearch";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, sharedExpandButtonIconsStyles, styledScrollbar } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    mergeCss: true,
    expandIconProps: {
        src: ArrowDown,
        size: 13,
        css: css`
            &${IconWrapper}, svg {
                width: 9px;
            }
        `,
    },
    collapseIconProps: {
        src: ArrowUp,
        size: 13,
        css: css`
            &${IconWrapper}, svg {
                width: 9px;
            }
        `,
    },
    titleTypographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.bold,
    },
    headerProps: {
        css: css`
            border: none;
            border-top: 1px solid ${color("common.border")};
            min-height: 33px;
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 10px 8px;
                border: none;
            }
        `,
    },
    panelProps: {
        css: css`
            border: none;
            padding: 0 10px 10px 8px;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBox = productListFilterAccordionSectionStyles.checkBoxSelected = {
    css: css<CheckboxStyleProps>`
        width: 100%;
        &&& label {
            display: flex;
            justify-content: space-between;
            margin-left: 8px;
            word-break: keep-all;
            gap: 4px;
        }
    `,
    typographyProps: {
        lineHeight: "17px",
        css: css`
            word-break: break-all;
            width: 100%;
        `,
    },
};
productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        flex-direction: row;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    `,
};

productListFilterAccordionSectionStyles.facetFilterTextField = {
    iconProps: {
        src: IconSearch,
        color: "primary",
        css: css`
            &${IconWrapper}, svg {
                width: 16px;
                height: 16px;
            }
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-bottom: 8px;
        `,
    },
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        position: relative;
        display: flex;
        flex-direction: column;
        max-height: 254px;
        overflow-x: hidden;
        padding: ${({ scrollable }: any) => (scrollable ? "2px 10px 2px 0px" : "2px 14px 2px 0px")};
        width: 100%;
        ${styledScrollbar({ width: 4 })}
    `,
};

productListFilterAccordionSectionStyles.seeMoreLink = {
    ...createLinkIconStyles(IconPlus, {
        ...sharedExpandButtonIconsStyles,
        css: css`
            margin-top: 4px;
        `,
    }),
};

productListFilterAccordionSectionStyles.seeLessLink = {
    ...createLinkIconStyles(IconMinus, {
        ...sharedExpandButtonIconsStyles,
        css: css`
            margin-top: 4px;
        `,
    }),
};
